var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraIcon = function SvgCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.001,
    cy: 9.998,
    r: 8.333,
    fill: "#FDF2EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CameraIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "m10.883 6.667.763.833h1.687v5H6.667v-5h1.687l.763-.833zm.367-.833h-2.5l-.762.833H6.667a.836.836 0 0 0-.834.833v5c0 .459.375.834.834.834h6.666a.836.836 0 0 0 .834-.834v-5a.836.836 0 0 0-.834-.833h-1.32zM10 8.75c.688 0 1.25.563 1.25 1.25s-.562 1.25-1.25 1.25-1.25-.562-1.25-1.25.563-1.25 1.25-1.25m0-.833a2.084 2.084 0 1 0 .002 4.168A2.084 2.084 0 0 0 10 7.917"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CameraIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h10v10H5z"
  })))));
};
export default SvgCameraIcon;